import { IActivityAction } from '@models/actions/IBaseAction';
import { createModalExecutor } from '@organisms/actions/createModalExecutor';
import { IChangeControllerProps } from './IChangeControllerProps';
import { ChangeControllerModal } from './ChangeControllerModal';

export const ChangeControllerExecutor = createModalExecutor<IChangeControllerProps>({
    modal: ChangeControllerModal,
    defaultModalSize: 'l',
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        processId: objId,
        docId: (action as IActivityAction)?.docId ?? '-1',
        actionKey: action.key,
        title: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
